import { forwardRef, KeyboardEventHandler } from 'react';
import { Input, InputProps } from './Input';

const allowedCodes = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'];
const allowedKeyCodes = [8, 46, 9, 37, 39];

export const NumericInput = forwardRef<HTMLInputElement, InputProps>((props: InputProps, ref: any) => {
  const handleNumericChars: KeyboardEventHandler<HTMLInputElement> = e => {
    if (
      // for backward compatibility support for keyCode
      (e.keyCode === undefined || !allowedKeyCodes.includes(e.keyCode)) &&
      !allowedCodes.includes(e.code) &&
      !['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(e.key)
    ) {
      e.preventDefault();
    }
  };

  return (
    <Input
      {...props}
      ref={ref}
      onKeyDown={handleNumericChars}
      inputMode={'numeric'}
    />
  );
});
